export { MedicalDocumentViewModal } from './ui';
